var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300.68 128.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 248.38,
    y1: 64.41,
    x2: 0,
    y2: 64.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 237.39,
    y1: 58.79,
    x2: 10.99,
    y2: 58.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 226.39,
    y1: 53.18,
    x2: 21.99,
    y2: 53.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 215.4,
    y1: 47.57,
    x2: 32.98,
    y2: 47.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 204.4,
    y1: 41.95,
    x2: 43.98,
    y2: 41.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 193.41,
    y1: 36.34,
    x2: 54.97,
    y2: 36.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 182.41,
    y1: 30.72,
    x2: 65.97,
    y2: 30.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 171.42,
    y1: 25.11,
    x2: 76.96,
    y2: 25.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 160.42,
    y1: 19.49,
    x2: 87.96,
    y2: 19.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 149.43,
    y1: 13.88,
    x2: 98.95,
    y2: 13.88,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m247.38,1.99c0,69.38-55.26,125.82-123.19,125.82S1,71.37,1,1.99c0-.67.01-1.33.02-1.99H.02c-.01.66-.02,1.33-.02,1.99,0,69.93,55.71,126.82,124.19,126.82S248.38,71.92,248.38,1.99c0-.67-.01-1.33-.02-1.99h-1c.01.66.02,1.33.02,1.99Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m236.39,1.99c0,63.19-50.33,114.59-112.2,114.59S11.99,65.18,11.99,1.99c0-.67.01-1.33.02-1.99h-1c-.01.66-.02,1.33-.02,1.99,0,63.74,50.78,115.59,113.2,115.59S237.39,65.73,237.39,1.99c0-.67-.01-1.33-.02-1.99h-1c.01.66.02,1.33.02,1.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m225.39,1.99c0,57-45.4,103.36-101.2,103.36S22.99,58.99,22.99,1.99c0-.67.01-1.33.02-1.99h-1c-.01.66-.02,1.33-.02,1.99,0,57.55,45.85,104.36,102.2,104.36S226.39,59.54,226.39,1.99c0-.67-.01-1.33-.02-1.99h-1c.01.66.02,1.33.02,1.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m214.4,1.99c0,50.8-40.47,92.14-90.21,92.14S33.98,52.8,33.98,1.99c0-.67.01-1.33.02-1.99h-1c-.01.66-.02,1.33-.02,1.99,0,51.36,40.92,93.14,91.21,93.14S215.4,53.35,215.4,1.99c0-.67-.01-1.33-.02-1.99h-1c.01.66.02,1.33.02,1.99Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m203.4,1.99c0,44.61-35.53,80.91-79.21,80.91S44.98,46.61,44.98,1.99c0-.67.03-1.33.05-1.99h-1c-.02.67-.05,1.33-.05,1.99,0,45.16,35.98,81.91,80.21,81.91S204.4,47.16,204.4,1.99c0-.67-.03-1.33-.05-1.99h-1c.02.67.05,1.33.05,1.99Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m192.41,1.99c0,38.42-30.6,69.68-68.22,69.68S55.97,40.42,55.97,1.99c0-.67.03-1.33.05-1.99h-1c-.02.66-.05,1.33-.05,1.99,0,38.97,31.05,70.68,69.22,70.68S193.41,40.97,193.41,1.99c0-.67-.03-1.33-.05-1.99h-1c.02.66.05,1.33.05,1.99Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m181.41,1.99c0,32.23-25.67,58.45-57.22,58.45S66.97,34.22,66.97,1.99c0-.67.03-1.33.05-1.99h-1c-.02.66-.05,1.33-.05,1.99,0,32.78,26.12,59.45,58.22,59.45s58.22-26.67,58.22-59.45c0-.67-.03-1.33-.05-1.99h-1c.02.66.05,1.33.05,1.99Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m170.42,1.99c0,26.04-20.74,47.22-46.23,47.22S77.96,28.03,77.96,1.99c0-.67.02-1.33.05-1.99h-1c-.03.66-.05,1.33-.05,1.99,0,26.59,21.19,48.22,47.23,48.22S171.42,28.58,171.42,1.99c0-.67-.02-1.33-.05-1.99h-1c.03.66.05,1.33.05,1.99Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m159.42,1.99c0,19.85-15.81,35.99-35.23,35.99S88.96,21.84,88.96,1.99c0-.67.02-1.33.06-1.99h-1c-.03.66-.05,1.33-.05,1.99,0,20.4,16.25,36.99,36.23,36.99S160.42,22.39,160.42,1.99c0-.67-.02-1.33-.05-1.99h-1c.04.66.06,1.32.06,1.99Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m148.43,1.99c0,13.66-10.87,24.76-24.24,24.76s-24.24-11.11-24.24-24.76c0-.67.03-1.34.09-1.99h-1c-.05.66-.08,1.32-.08,1.99,0,14.21,11.32,25.76,25.24,25.76s25.24-11.56,25.24-25.76c0-.67-.03-1.34-.08-1.99h-1c.05.66.09,1.32.09,1.99Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg4);
export default __webpack_public_path__ + "static/media/bg-img-4.3b2b39f36912644ae06fc54646a6fbeb.svg";
export { ForwardRef as ReactComponent };